module.exports = __webpack_public_path__ + "static/media/react1Prop.84d91665.png";